import React, {Component} from "react";
import { NavLink } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import CustomDropdown from "../components/CustomDropdown";
import CustomDropdownSelfServe from "../components/CustomDropdownSelfServe";
import Alert from 'react-bootstrap/Alert'

import 'bootstrap/dist/css/bootstrap.min.css';
import "./UploadPostmanCollectionPage.css";
// import Sidebar from "../components/Sidebar";
import logo from  "../components/Myntra_logo.png";

import {amcClientId, amcBaseUrl} from  "../common.config"

import qs from "qs";

var clientId = amcClientId || 'myntra-swagger-7f9ec6f9-a332-41cd-a4ea-dbe84b1c713f';
var currentUrl = window.location.toString();
var fullUrl = amcBaseUrl + '/login?cidx=' + encodeURIComponent(clientId) + '&pageRequested=' + encodeURIComponent(currentUrl);


class SelfServePageService extends Component {
    state = {
        swaggerRegisteredTeams: [],
        serviceName: "",
        serviceId: 0,
        teamName: "",
        selectedTeamId: 0,
        selectedTeamName: "",
        key: "team"
    };

    componentDidMount() {

        if(this.checkURLParams()){
            var at = qs.parse(window.location.search).access_token;
            var rt = qs.parse(window.location.search).refresh_token;
            //validate at, rt
            this.setCookie("erp.at", at, 1);
            this.setCookie("erp.rt", rt, 1);
            this.setCookie("amc.enabled", true);
        }
        let isTokenValid = this.checkAuthenticated() ? this.validateToken() : false;
        console.log(isTokenValid);
        if(!isTokenValid) {
            this.deleteCookie("erp.at");
            this.deleteCookie("erp.rt");
            window.location.assign(fullUrl);
        }

        else{
            this.getSwaggerTeams()
                .then(res => {
                    this.setState({swaggerRegisteredTeams: res})
                })
                .catch(err => console.log(err));
        }
    }

    setKey = async(changeKey) => {
        this.setState({key: changeKey});
    }

    getSwaggerTeams = async () => {
        const response = await fetch('/getSwaggerTeams');
        const body = await response.json();
        console.log(body);
        if (response.status !== 200) throw Error(body.message);
        return body;
    }

    addNewTeam = async () => {
        let url = '/addTeam/' + this.state.teamName;
        const response = await fetch(url);
        const body = await response.json();
        console.log("New team");
        console.log(body[0]);
        if (response.status !== 200) throw Error(body.message);
    };

    addSampleJson = async () => {
        console.log("the service id in the last table is: ");
        console.log(this.state.serviceId);
        let url = '/addSampleJson/' + this.state.serviceId;
        const response = await fetch(url);
        const body = await response.json();
        if (response.status !== 200) throw Error(body.message);
        else this.setState({serviceName: "", serviceId: 0, selectedTeamId: 0, selectedTeamName: ""});
    };

    getServiceId = async () => {
        let url = '/getServiceId/' + this.state.serviceName;
        const response = await fetch(url);
        const body = await response.json();
        this.state.serviceId = body[0]['id'];
        if (response.status !== 200) throw Error(body.message);
        else this.addSampleJson();
    }

    addNewService = async () => {
        let data = {
            method: "post",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },

            body: JSON.stringify({
                clientName: this.state.serviceName,
                active: '1',
                createdBy: 'system',
                teamId: this.state.selectedTeamId
            })
        }
        const response = await fetch('/addService/', data);
        const body = await response.json();
        console.log(body);
        if (response.status !== 200) throw Error(body.message);
        else  this.getServiceId();
    };

    getTeamId = async () => {
        const response = await fetch('/getTeamId/sampleTeam');
        const body = await response.json();
        console.log("Get team id:");
        console.log(body[0]['id']);
        if (response.status !== 200) throw Error(body.message);
    }

    //when button clicked go and add the new team
    handleSubmit = (event) => {

        this.addNewService();
        alert('Service Onboarded: ' + this.state.serviceName);
        event.preventDefault();

    };

    handleChange = (event) => {
        this.setState({serviceName: event.target.value});
    }

    updateSelectedTeamId = (teamId, teamName) => {
        this.setState({selectedTeamId: teamId, selectedTeamName: teamName});
    }

    addNewTeam = async () => {
        let url = '/addTeam/' + this.state.teamName;
        const response = await fetch(url);
        const body = await response.json();
        console.log("New team");
        console.log(body[0]);
        if (response.status !== 200) throw Error(body.message);
    };

    //when button clicked go and add the new team
    handleSubmitTeam = (event) => {
        this.addNewTeam();
        alert('Team Onboarded: ' + this.state.teamName);
        event.preventDefault();
        this.setState({teamName: ""});
    };

    handleChangeTeam = (event) => {
        this.setState({teamName: event.target.value});
    }

    validateToken = async () => {
        const response = await fetch('/validateToken');
        if(response.status !== 200) return false;
        console.log(response.status);
        const body = await response.json();
        // if(!body["isTokenValid"]) window.location.assign(fullUrl);
        return body["isTokenValid"];
    }

    getCookie = (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    setCookie =(name,value,days) => {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    deleteCookie = (name) => {
        this.setCookie(name, '', -1)
    }

    checkAuthenticated = () => {
        var at = this.getCookie("erp.at");
        var rt = this.getCookie("erp.rt");
        return (at !== null && rt !== null);
    }

    checkURLParams = () => {
        var at = qs.parse(window.location.search).access_token;
        var rt = qs.parse(window.location.search).refresh_token;
        return at !== undefined && rt !==undefined
    }

    render() {
        return (

            this.props.disabled?<div></div>:
                <div className="UploadPostmanCollectionPage">
                    <div className="UploadPostmanCollectionPageHeader">
                        <img src={logo} alt="Myntra Logo"/>
                        <div id="header-text">
                            <div>
                                <h1>Developer API</h1>
                            </div>
                        </div>
                        <div id="title">
                            <h1>Onboard Team/Service</h1>
                        </div>

                        <div className="wrap">
                            <NavLink className="UploadBtn" to="/internal" exact>
                                <Button variant="outline-light">Back To Home</Button>
                            </NavLink>
                        </div>
                    </div>
                    <div className="UploadPostmanCollectionPageBody">
                        <div className="MainContent">
                            <div style={{height: "300px", padding: "20px 0px 0px 0px"}} className="UploadContainer">
                                <Tabs
                                    id="controlled-tab-example"
                                    activeKey={this.state.key}
                                    onSelect={(k) => this.setKey(k)}
                                >
                                    <Tab eventKey="team" title="Onboard Team">
                                        <form style={{alignContent:"center", justifyContent: "center"}} onSubmit={this.handleSubmitTeam}>
                                            <br></br>
                                            <br></br>
                                            <label>
                                                <input style={{textAlign:"center"}} type="text" value={this.state.teamName} onChange={this.handleChangeTeam} placeholder="Team Name"/>
                                            </label>
                                            <br></br>
                                            <Button type="submit" value="Submit" variant="flat">Submit</Button>
                                            <br></br>
                                            <br></br>
                                        </form>
                                    </Tab>
                                    <Tab eventKey="service" title="Onboard Service">
                                        <br></br>
                                        <CustomDropdownSelfServe
                                            swaggerRegisteredTeams={this.state.swaggerRegisteredTeams}
                                            updateSelectedTeamId={this.updateSelectedTeamId}
                                            selectedTeamName={this.state.selectedTeamName} />
                                        <br/>
                                        <form onSubmit={this.handleSubmit}>
                                            <label>
                                                <input style={{textAlign:"center"}} type="text" value={this.state.serviceName} onChange={this.handleChange} placeholder="Service Name"/>
                                            </label>
                                            <br></br>
                                            <Button type="submit" value="Submit" variant="flat">Submit</Button>
                                        </form>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
        );
    }
}

export default SelfServePageService;